<mode-inline-toast
  [placement]="placement"
  [toastMessage]="toast$ | async"
  (done)="toastComplete()"
>
  <ng-content></ng-content>
</mode-inline-toast>
